import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToSnakeCase, transformClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId, opportunityId) => {
  const endpoint = URLS.venue.opportunitiesReject(venueId);
  return httpClient
    .post(endpoint, transformKeysToSnakeCase({ opportunityIds: [opportunityId] }))
    .then(transformClientResponse);
};

export default makeEntityScaffold('SAGA.API.OPPORTUNITY_REJECT_TRACKING', handler, { defaultKey: 1 });
